import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization/userSlice'
import { externalProductPestPacName } from '@sales-center/common'

export const useGetClosedWonQueueUrl = () => {
  const { externalProduct, clientUrl } = useSelector(selectCurrentUser)

  switch (externalProduct) {
    case externalProductPestPacName:
      return `${clientUrl}/salescenter/closedWonQueue/`
    default:
      return ''
  }
}
